'use strict';

var label = require('../util/label');

module.exports = imageReference;

function imageReference(node) {
  return '![' + (this.encode(node.alt, node) || '') + ']' + label(node);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/image-reference.js
// module id = 300
// module chunks = 96961042003272 139266963665775